import { AxiosResponse } from 'axios';
import { pageVisitHistoryList } from '@/api/pageVisitHistory';
import { AppError } from '@/errors/appError';
import { baseListService, isRequestCanceled } from '@/services/baseService';
import { IListParams } from '@/types';
import { IPageVisitHistoryApiListResponse, IPageVisitHistoryFilters } from '@/types/pageVisitHistory';

export const pageVisitHistoryService = {
    async list(params: IListParams<IPageVisitHistoryFilters>): Promise<AxiosResponse<IPageVisitHistoryApiListResponse>> {
        try {
            return await baseListService<IPageVisitHistoryApiListResponse>(pageVisitHistoryList, params);
        } catch (e) {
            if (isRequestCanceled(e)) throw e;
            console.error('PageVisitHistory API Error:', e);
            throw new AppError('Unable to load page visit history, request error', { cause: e });
        }
    },
};
